import type { GridRowId, GridTreeNode } from '@mui/x-data-grid-pro';

export type DropPosition = 'above' | 'below' | 'inside';

export interface DropTarget {
  rowId: GridRowId;
  position: DropPosition;
  isCrossParent?: boolean;
}

export const calculateDropPosition = (clientY: number, rowRect: DOMRect): 'above' | 'below' => {
  const relativeY = clientY - rowRect.top;
  return relativeY < rowRect.height / 2 ? 'above' : 'below';
};

export const isSameParent = (sourceNode: GridTreeNode, targetNode: GridTreeNode): boolean =>
  sourceNode.parent === targetNode.parent;

export const isNoOpDrop = (
  sourceRowId: GridRowId,
  targetRowId: GridRowId,
  position: DropPosition,
  prevSiblingId: GridRowId | null,
  nextSiblingId: GridRowId | null,
): boolean => {
  if (sourceRowId === targetRowId) return true;
  if (position === 'above' && targetRowId === nextSiblingId) return true;
  if (position === 'below' && targetRowId === prevSiblingId) return true;
  return false;
};
